<template>
    <CCard>
        <CCardHeader>
            <strong>Комментарии администрации</strong>
        </CCardHeader>
        <CCardBody>
            <template v-if="comments.length">
                <CRow
                    v-for="comm in comments"
                    :key="comm.id"
                    class="comment pt-1 pb-1 mb-2 ml-0 mr-0"
                >
                    <CCol col="8" class="author">{{ comm.who }}</CCol>
                    <CCol col="4" class="author text-right">{{ formatDate(comm.created_at) }}</CCol>
                    <CCol class="comment__text pl-4">
                        <span v-if="comm.status">Статус: {{ orderStatusTitle(comm.status) }} <br /></span>
                        {{ comm.text }}
                    </CCol>
                </CRow>
            </template>
            <template v-else>
                <CRow class="pt-1 pb-1 mb-2 text-center">
                    <CCol>Пусто.</CCol>
                </CRow>
            </template>
            <div class="comment__form d-flex align-items-center">
                <CTextarea
                    v-model="comment"
                    placeholder="Комментарий..."
                    class="m-0 mr-2 w-100"
                    rows="1"
                />
                <CButton
                    shape="pill"
                    color="primary"
                    variant="outline"
                    :disabled="!comment"
                    @click="sendComment"
                >
                    <CIcon
                        :height="48"
                        :content="$options.icons.cilSend"
                        class="handle"
                    />
                </CButton>
            </div>
        </CCardBody>
    </CCard>
</template>

<script>
    import Vue from 'vue';
    import { cilSend } from '@coreui/icons';
    import moment from 'moment';

    const {
        orderStatusTitle,
    } = require('../../utils/order-views');

    export default {
        name: 'OrderComments',

        icons: {
            cilSend
        },

        props: {
            id: {
                type: Number,
                default: null,
            },
            order: {
                type: Object,
                default: () => ({}),
            },
        },

        data() {
            return {
                isAuthorized: false,
                comments: [],
                comment: '',
            };
        },

        computed: {},

        watch: {},

        async mounted() {
            await this.loadData();
        },

        methods: {
            async loadData() {
                const comments = await Vue.axios.get('/orders/' + this.id + '/comments');
                const logs = await Vue.axios.get('/orders/' + this.id + '/logs');
                this.comments = comments.data;
                if (logs.data.length) {
                    this.comments = [
                        ...this.comments,
                        ...logs.data
                            .filter(log => !!log?.payload?.comment)
                            .map(log => ({
                                id: log.id,
                                created_at: log.created_at,
                                text: log?.payload?.comment,
                                status: log?.status,
                                who: log?.who,
                            }))
                    ].sort((a, b) => moment(a.created_at).diff(moment(b.created_at)));
                }
            },

            sendComment() {
                Vue.axios
                    .post(`/orders/${this.id}/comments`, {
                        comment: this.comment,
                    })
                    .then(resp => {
                        this.comment = '';
                        this.loadData();
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Не удалось сохранить комментарий.');
                    });
            },

            orderStatusTitle(status) {
                if (this?.order?.ed?.items?.length) {
                    return orderStatusTitle(
                        status,
                        this.order.type,
                        this.order.payment_type,
                        this?.order?.ed?.items[0]?.entity?.statuses,
                        this.order.delivery_type
                    );
                }
                return orderStatusTitle(
                    status,
                    this.order.type,
                    this.order.payment_type,
                    null,
                    this.order.delivery_type
                );
            },

            formatDate(date) {
                return moment(date).format('HH:mm DD.MM')
            },
        },
    };
</script>

<style scoped>
.comment {
    background: #e5e5e5;
    border-radius: 10px;
}
.comment .comment__text {
    font-weight: 500;
}
</style>
